<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_STEP_COVER from '../../assets/step-cover.png';

interface Props {
  coverColor: string;
}

defineProps<Props>();
</script>

<template>
<div class="cover">
  <CarouselMobile :mobileFrameImage="IMG_STEP_COVER">
    <template #background>
      <div class="w-full h-full" :style="`background-color: ${coverColor}`"></div>
    </template>
  </CarouselMobile>
</div>
</template>
